import { createDefaultTyrann } from '@apis/common';
import {
  adminPatchCustomsInstruction,
  customsInstruction,
  customsInstructionList,
  customsInstructionListQueryParams,
  patchCustomsInstruction,
} from '@models/CustomsInstruction';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const customsInstructionApis = createDefaultTyrann({
  '/customs-instruction/': {
    get: {
      query: customsInstructionListQueryParams,
      response: {
        200: customsInstructionList,
        404: t.type({}),
      },
    },
  },
  '/customs-instruction/{d2d_no}/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: customsInstruction,
        404: t.type({}),
      },
    },
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: patchCustomsInstruction,
      response: {
        200: customsInstruction,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/customs-instruction/{d2d_no}/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: customsInstruction,
        404: t.type({}),
      },
    },
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: adminPatchCustomsInstruction,
      response: {
        200: customsInstruction,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
});
